import { queryClient } from "@/queryClient";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { queries } from "@/modules/resources/services/queries";

export const Route = createFileRoute("/resources/$id/versions/")({
  staticData: {
    title: "versions.title",
  },
  loader: async ({ params }) => {
    // Because we use cached resource data (resource type) in the versions layout, we need to ensure the resource is loaded
    const resource = await queryClient.ensureQueryData(queries.getResource(Number(params.id)));
    const latestVersion = resource.versions?.[0];

    if (!latestVersion?.versionId) {
      return;
    }

    throw redirect({
      to: "/resources/$id/versions/$versionId/general",
      params: { id: params.id, versionId: latestVersion.versionId.toString() },
      from: "/resources/$id/versions/",
    });
  },
});
